import { render, staticRenderFns } from "./JInput.vue?vue&type=template&id=76536f5a&scoped=true&"
import script from "./JInput.vue?vue&type=script&lang=js&"
export * from "./JInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76536f5a",
  null
  
)

export default component.exports